// these are the types we allow in a column for a metric
// i.e.: measure, timestamp, comparison, color, etc.
export type Value = string | number | boolean | Date | undefined | null;

export type DataRow = Record<string, Value>;

export type DataTable = ReadonlyArray<DataRow>;

export const isNullOrUndefined = (value: Value): value is null | undefined => value === undefined || value === null;
